import React, { Component } from 'react'
import * as R from 'ramda'
import i18n from 'i18next'

import Button from '../../../UniformComponents/Button'
import Select from '../../form/Select'
import Checkbox from '../../form/Checkbox'
import { stages } from './store'

class DownloadOptions extends Component {
    fields = {}

    register = (name, validate) => {
        const { fields } = this
        fields[name] = validate
    }

    unregister = (name) => {
        const { fields } = this
        Reflect.deleteProperty(fields, name)
    }

    changeOption = ({ value, name }) => {
        const { store } = this.props

        store.downloadOptions[name] = value
    }

    renderCsvOptions = () => {
        const { pageType, store } = this.props
        const { downloadType } = store

        if (downloadType !== 'csv') return null

        return (
            <>
                <Select
                    placeholder={i18n.t('report_delimiter_select')}
                    name="delimiter"
                    label={i18n.t('download.modal.delimiter')}
                    onBlur={this.changeOption}
                    register={this.register}
                    unregister={this.unregister}
                    isMandatory
                    options={[
                        {
                            label: i18n.t('report_delimiter_comma'),
                            value: 'comma',
                        },
                        {
                            label: i18n.t('report_delimiter_semicolon'),
                            value: 'semicolon',
                        },
                        {
                            label: i18n.t('report_delimiter_tab'),
                            value: 'tab',
                        },
                    ]}
                />
                { pageType === 'report' && (
                    <>
                        <Checkbox
                            name="includeColumnMetadata"
                            label={i18n.t('download.modal.include_metadata')}
                            onBlur={this.changeOption}
                        />
                        <Checkbox
                            name="numericExport"
                            label={i18n.t('report_csv_export_numeric')}
                            onBlur={this.changeOption}
                        />
                    </>
                )}
            </>
        )
    }

    renderPDFOptions = () => {
        const { store } = this.props
        const { downloadType } = store

        if (downloadType !== 'pdf') return null

        return (
            <>
                <Select
                    placeholder={i18n.t('report_delimiter_select')}
                    name="openEnded"
                    label={i18n.t('report_include_open_ended')}
                    onBlur={this.changeOption}
                    register={this.register}
                    unregister={this.unregister}
                    isMandatory
                    options={[
                        {
                            label: i18n.t('gen_yes'),
                            value: true,
                        },
                        {
                            label: i18n.t('gen_no'),
                            value: false,
                        },
                    ]}
                />
            </>
        )
    }

    download = () => {
        const { store } = this.props
        const { downloadOptions } = store

        const isValid = Object.entries(this.fields).every(([name, validate]) => (
            validate({
                name,
                value: R.pathOr(null, [name], downloadOptions),
            }, true)
        ))

        if (isValid) {
            store.setStage(stages.DOWNLOADING)
        }
    }

    render() {
        const { onClose, store: downloadStore } = this.props
        const { tokenData } = downloadStore.appStore

        return (
            <>
                <div className="uc-modal__header">
                    <h2>{i18n.t('download.modal.export_options')}</h2>
                    <p className="uc-modal__desc">{i18n.t('download.modal.download_options.subtitle')}</p>
                </div>
                <div className="body">
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '20px',
                            width: '300px',
                            margin: 'auto',
                        }}
                    >
                        {this.renderCsvOptions(tokenData.isAdmin)}
                        {this.renderPDFOptions(tokenData.isAdmin)}
                    </div>
                </div>
                <div className="uc-modal__button-panel">
                    <Button
                        label={i18n.t('cancel')}
                        cssClass="tertiary"
                        onClick={onClose}
                    />
                    <Button
                        label={i18n.t('download')}
                        cssClass="primary"
                        onClick={this.download}
                    />
                </div>
            </>
        )
    }
}

export default DownloadOptions
